import React from "react";

class Page404 extends React.Component {
    public render() {
        return <div>page 404</div>;
    }
}

export default Page404;
